import {Component, OnInit} from '@angular/core';
import {ComplainRegisterService} from './complain-register.service';
import {Complain} from './model/complain';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
  selector: 'app-complain-register',
  templateUrl: './complain-register.component.html',
  styleUrls: ['./complain-register.component.css']
})
export class ComplainRegisterComponent implements OnInit {
  constructor(private apiService: ComplainRegisterService, private router: Router) {
  }

  showMsg: boolean = false;
  public readonly submitted: boolean = false;
  selectedsubCate: string = '';
  subCates: any = [];
  complainId: any;

  ngOnInit(): void {
    this.complainId=null;
  }

  createOrUpdatePolicy(form: NgForm) {
    this.apiService.createComplain(form.value).subscribe(res => {
      console.log(res);
      this.complainId = res
      this.showMsg = true;

    });
    this.resetForm(form);

  }

  radioChangeHandler(event: any) {
    this.selectedsubCate = event.target.value;
  }


  resetForm(form: NgForm) {
    console.log("RESET form called");
    form.resetForm();
  }

  onOptionsSelected(value: string) {
    this.subCates = this.apiService.extracted(value);
  }

}
